module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/224-portugal-ee4a070c97394683f652b0071b2a694e.svg";